<template>
  <div class="c-list-grid">
    <p>
      <ion-row class="ion-align-items-center">
        <ion-col size="auto">
          <ion-icon
            size="large"
            :src="require('@lib/assets/icons/icon_zahnbehandlung.svg')"
          />
        </ion-col>
        <ion-col>
          Zahnbehandlung
        </ion-col>
      </ion-row>
    </p>
    <p>
      <ion-row class="ion-align-items-center">
        <ion-col size="auto">
          <ion-icon
            size="large"
            :src="require('@lib/assets/icons/icon_implantologie.svg')"
          />
        </ion-col>
        <ion-col>
          Implantologie
        </ion-col>
      </ion-row>
    </p>
    <p>
      <ion-row class="ion-align-items-center">
        <ion-col size="auto">
          <ion-icon
            size="large"
            :src="require('@lib/assets/icons/icon_zahnfuellungen.svg')"
          />
        </ion-col>
        <ion-col>
          Zahnfüllungen
        </ion-col>
      </ion-row>
    </p>
    <p>
      <ion-row class="ion-align-items-center">
        <ion-col size="auto">
          <ion-icon
            size="large"
            :src="require('@lib/assets/icons/icon_profi_zahnreinigung.svg')"
          />
        </ion-col>
        <ion-col>
          Professionelle Zahnreinigung
        </ion-col>
      </ion-row>
    </p>

    <p>
      <ion-row class="ion-align-items-center">
        <ion-col size="auto">
          <ion-icon
            size="large"
            :src="require('@lib/assets/icons/icon_parodontologie.svg')"
          />
        </ion-col>
        <ion-col>
          Parodontologie
        </ion-col>
      </ion-row>
    </p>
    <!-- <p>
    <ion-row class="ion-align-items-center">
      <ion-col size="auto">
        <ion-icon
          size="large"
          :src="require('@lib/assets/icons/icon_zahnheilkunde.svg')"
        />
      </ion-col>
      <ion-col>
        Ästhetische Zahnheilkunde
      </ion-col>
    </ion-row>
  </p> -->
    <p>
      <ion-row class="ion-align-items-center">
        <ion-col size="auto">
          <ion-icon
            size="large"
            :src="require('@lib/assets/icons/icon_zahnersatz.svg')"
          />
        </ion-col>
        <ion-col>
          Hochwertiger Zahnersatz
        </ion-col>
      </ion-row>
    </p>
    <p>
      <ion-row class="ion-align-items-center">
        <ion-col size="auto">
          <ion-icon
            size="large"
            :src="require('@lib/assets/icons/icon_kieferchirugie.svg')"
          />
        </ion-col>
        <ion-col>
          Zahnärztliche Kieferchirurgie, u.v.m.
        </ion-col>
      </ion-row>
    </p>
  </div>
</template>

<script>
import { IonRow, IonCol, IonIcon } from "@ionic/vue";

export default {
  components: { IonRow, IonCol, IonIcon },
};
</script>

<style></style>
